import React from 'react';
import { Search, MessageCircle, Phone, Mail, ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { useNavigation } from '../context/NavigationContext';
import { Screen } from '../types';
import { Header } from '../components/ui/Header';
export function HelpCenterScreen() {
  const {
    navigate
  } = useNavigation();
  const faqs = ['How do I track my order?', 'What is your return policy?', 'How long does delivery take?', 'How do I cancel my order?', 'My payment failed, what should I do?'];
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} className="min-h-screen bg-gray-50" data-id="element-578">
      <Header title="Help Center" data-id="element-579" />

      <div className="bg-primary p-6 text-white" data-id="element-580">
        <h2 className="text-2xl font-bold mb-2" data-id="element-581">How can we help you?</h2>
        <p className="text-primary-100 mb-4" data-id="element-582">
          Search our knowledge base or contact support.
        </p>

        <div className="relative" data-id="element-583">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-584" />
          <input type="text" placeholder="Search for answers..." className="w-full bg-white rounded-xl py-3 pl-10 pr-4 text-gray-900 focus:outline-none focus:ring-2 focus:ring-accent" data-id="element-585" />
        </div>
      </div>

      <div className="p-4 space-y-6" data-id="element-586">
        <section data-id="element-587">
          <h3 className="font-bold text-gray-900 mb-3" data-id="element-588">Contact Support</h3>
          <div className="grid grid-cols-3 gap-3" data-id="element-589">
            <button onClick={() => navigate(Screen.LIVE_CHAT)} className="bg-white p-4 rounded-2xl shadow-sm border border-gray-50 flex flex-col items-center gap-2 active:scale-95 transition-transform" data-id="element-590">
              <div className="w-10 h-10 rounded-full bg-primary-50 flex items-center justify-center text-primary" data-id="element-591">
                <MessageCircle className="w-5 h-5" data-id="element-592" />
              </div>
              <span className="text-xs font-medium text-gray-700" data-id="element-593">
                Live Chat
              </span>
            </button>
            <button className="bg-white p-4 rounded-2xl shadow-sm border border-gray-50 flex flex-col items-center gap-2 active:scale-95 transition-transform" data-id="element-594">
              <div className="w-10 h-10 rounded-full bg-primary-50 flex items-center justify-center text-primary" data-id="element-595">
                <Phone className="w-5 h-5" data-id="element-596" />
              </div>
              <span className="text-xs font-medium text-gray-700" data-id="element-597">Call Us</span>
            </button>
            <button className="bg-white p-4 rounded-2xl shadow-sm border border-gray-50 flex flex-col items-center gap-2 active:scale-95 transition-transform" data-id="element-598">
              <div className="w-10 h-10 rounded-full bg-primary-50 flex items-center justify-center text-primary" data-id="element-599">
                <Mail className="w-5 h-5" data-id="element-600" />
              </div>
              <span className="text-xs font-medium text-gray-700" data-id="element-601">Email</span>
            </button>
          </div>
        </section>

        <section data-id="element-602">
          <h3 className="font-bold text-gray-900 mb-3" data-id="element-603">
            Frequently Asked Questions
          </h3>
          <div className="bg-white rounded-2xl shadow-sm border border-gray-50 overflow-hidden" data-id="element-604">
            {faqs.map((faq, idx) => <button key={idx} className={`w-full flex items-center justify-between p-4 text-left active:bg-gray-50 transition-colors ${idx !== faqs.length - 1 ? 'border-b border-gray-50' : ''}`} data-id="element-605">
                <span className="text-sm font-medium text-gray-700" data-id="element-606">{faq}</span>
                <ChevronRight className="w-4 h-4 text-gray-400 shrink-0" data-id="element-607" />
              </button>)}
          </div>
        </section>
      </div>
    </motion.div>;
}